import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// Service Worker Management - Deaktiviert alle Service Workers für API-Anfragen
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // WICHTIG: Unregister ALLE Service Workers (verhindert Caching-Probleme mit API)
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().then((success) => {
          if (success) {
            console.log('[SW] ✅ Service Worker deaktiviert:', registration.scope);
          }
        });
      });
    });
    
    // Registriere unseren eigenen Service Worker (der API-Anfragen NICHT cacht)
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('[SW] ✅ Neuer Service Worker registriert (API-Caching deaktiviert)');
      })
      .catch((error) => {
        // Ignore - Service Worker ist optional
        console.warn('[SW] Service Worker Registration fehlgeschlagen (optional):', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

